.container {
  width: 100%;
  margin-bottom: 1.5rem;

  .map {
    position: relative;
    height: 350px;
    width: 100%;
  }

  .loadindicator-container {
    position: absolute;
    top:  50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: white;
  }
}